export const informationTitles = {
  '/contacts': 'Контакты и реквизиты',
  '/payment': 'Оплата',
  '/delivery': 'Доставка',
  '/returns': 'Возврат и отмена',
  '/offer': 'Публичная оферта',
} as const;

export function isInformationPath(path: string): path is keyof typeof informationTitles {
  return Object.hasOwn(informationTitles, path);
}
